export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

import {bind} from 'kpc';

type DemoItem = {
    key: number
    role: 'ai' | 'user'
    content: string
};

interface Props {
    roles: Record<string, any>
    items: DemoItem[]
}

function createRoles(): Props['roles'] {
    return {
        ai: {
            placement: 'start',
            avatar: true,
            roleName: 'AI 助手',
        },
        user: {
            placement: 'end',
            avatar: true,
            roleName: '我',
            variant: 'outlined',
        },
    };
}

function createState(): Props {
    return {
        roles: createRoles(),
        items: [],
    };
}

function createItems(): DemoItem[] {
    return [
        {key: 1, role: 'ai', content: '欢迎使用对话工作台。'},
        {key: 2, role: 'user', content: '我想先看一下空态可以怎么自定义。'},
    ];
}

export default class extends Component<Props> {
    static template = template;

    static defaults() {
        return createState();
    }

    @bind
    clear() {
        this.set({
            items: [],
        });
    }

    @bind
    restore() {
        this.set({
            items: createItems(),
        });
    }
}